/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { themeTools } from 'native-base';
import { darkColors, lightColors, makeThemeColors } from '@springbig/shared';
import Settings from '../settings';
const theme = (darkTheme, lightTheme, colors) => ({
    space: {
        'space-2': '29px',
    },
    colors: {
        ...colors,
        ...makeThemeColors(darkColors(colors, darkTheme), lightColors(colors, lightTheme)),
    },
    components: {
        Box: {
            baseStyle: (props) => ({
                bg: themeTools.mode('transparent', 'transparent')(props),
            }),
        },
        Button: {
            baseStyle: (props) => ({
                color: themeTools.mode('black', 'white')(props)
            }),
        },
        Text: {
            baseStyle: (props) => ({
                color: themeTools.mode('black', 'white')(props)
            })
        },
        VStack: {
            baseStyle: (props) => ({
                bg: themeTools.mode('transparent', 'transparent')(props)
            }),
        },
        Radio: {
            baseStyle: (props) => ({
                color: themeTools.mode('black', 'red')(props)
            }),
        },
        Divider: {
            baseStyle: (props) => ({
                bg: themeTools.mode('neutral', 'neutral')(props)
            })
        },
        SliderFilledTrack: {
            baseStyle: (props) => ({
                bg: themeTools.mode('primary', 'primary')(props)
            })
        },
        SliderTrack: {
            baseStyle: (props) => ({
                bg: themeTools.mode('neutral', 'neutral')(props)
            })
        },
    },
});
if (Settings.fontFamily) {
    theme.fonts = {
        heading: Settings.fontFamily,
        body: Settings.fontFamily,
        mono: Settings.fontFamily,
    };
}
export default theme;
